<template class="map-group-page">
  <v-card>
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="classObj"
      hide-default-footer
      disable-pagination
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Map Group"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Map Group
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-map-group-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import clsx from "clsx";

import RMapGroupDialog from "@/modules/redactor/views/map-group/r-map-group-dialog.vue";
import VueTypes from "vue-types";
import {MapGroupModel} from "@/modules/redactor/models/map/MapGroupModel";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";

export default {
  name: "r-map-group-page",
  components: {RDialogPreviewCollection, AcDataTable, RMapGroupDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Code", value: "code"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(MapGroupModel)
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    classObj(item) {
      return clsx('map-group-page__item', {
        'cyan lighten-4': item.global,
      });
    },

    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs["dialog"].show(ViewRules.COPY, item.copy()).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item!");
            } else {
              RedactorUtils.pushMapGroup(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            if (this.item_duplicate(result)) {
              this.$alert("Duplicate item!");
            } else {
              RedactorUtils.pushMapGroup(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushMapGroup(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeMapGroup(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkMapGroups(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushMapGroup(result);
    },

    item_duplicate(item) {
      return this.items.find(v => {
        if (v.item && item.item && v.item.equal(item.item)) {
          return v.uid !== item.uid;
        }

        return false;
      });
    },

    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, MapGroupModel, "map-group")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getMapGroups();
  }
}

</script>

<style scoped lang="scss">
.map-group-page {
  &__item {
    white-space: nowrap;
  }
}

::v-deep .v-data-table thead th {
  white-space: nowrap;
}
</style>